import { createFileRoute } from '@tanstack/react-router';
import { InspectionPreparationListPage } from '@/features/nis2/pages/InspectionPreparationListPage';

export const Route = createFileRoute('/_authenticated/nis2/inspection-preparation/')({
  component: InspectionPreparationListPage,
});
